import { SxProps, Theme } from "@mui/material";

export const boxStyles = () => ({
  width: "52px",
  height: "50px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderLeftWidth: "0px",
  borderRightWidth: "0px",
  borderTop: "2px solid #E9E9E8",
  borderBottom: "2px solid #E9E9E8",
  boxSizing: "border-box",
  fontWeight: "600",
  fontSize: "1.25rem",
  fontFamily: '"Mulish",sans-serif'
})

export const getButtonStyles = (sx: SxProps<Theme>) => ({
  padding: "0px",
  border: "2px solid #E9E9E8",
  height: "50px",
  width: "40px",
  minWidth: "0px",
  ...sx,
  "&.Mui-disabled": {
    border: "2px solid #E9E9E8",
    opacity: "1",
    color: "#E9E9E8"
  }
})